export default __webpack_public_path__ + "static/media/spiritual.33e98f17.png";